<div class="row">
    <on-company-role-select
        (click)="$event.stopPropagation()"
        display="small"
        [disabled]="(currentUser$ | async)?.Id === empRole.Employee.Id"
        [(ngModel)]="empRole.Employee.Role"
        (change)="onChangeRole(empRole)"
    >
    </on-company-role-select>
</div>
